// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2aUHk","topBottomGutter":"Layout_topBottomGutter__2YvaP"};